module.exports = __webpack_public_path__ + "img/bg1.38d64932.png";